import { useLang } from "@/context/LanguageContext";
import { MaskWords } from "@/components/site/primitives";
import { Reveal } from "@/components/site/Reveal";

export default function Services() {
  const { t } = useLang();
  const s = t.services;

  return (
    <div className="bg-paper text-ink min-h-screen">
      {/* Header */}
      <section className="px-6 md:px-12 lg:px-20 pt-36 md:pt-48 pb-16 md:pb-24">
        <div className="eyebrow text-ink/50 mb-6">{s.label}</div>
        <MaskWords Tag="h1" text={s.title} className="display uppercase text-[15vw] md:text-[16vw] lg:text-[13vw] leading-[0.82] break-words" />
        <p className="mt-8 text-lg md:text-2xl leading-[1.5] text-ink/75 max-w-2xl">{s.intro}</p>
      </section>

      {/* Areas */}
      <section className="px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
        <div className="border-t border-ink/15">
          {s.groups.map((g, i) => (
            <Reveal key={i}>
              <div className="grid grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-b border-ink/15 group">
                <div className="col-span-12 lg:col-span-5">
                  <h2 className="display uppercase text-5xl md:text-6xl lg:text-7xl leading-[0.9] transition-transform duration-500 group-hover:translate-x-2">
                    {g.key}
                  </h2>
                </div>
                <div className="col-span-12 lg:col-span-6 lg:col-start-7">
                  <p className="serif text-2xl md:text-3xl leading-[1.25] text-ink/85 mb-8">{g.desc}</p>
                  <ul className="flex flex-wrap gap-2.5">
                    {g.items.map((it, k) => (
                      <li key={k} className="eyebrow border border-ink/25 rounded-full px-4 py-2 text-ink/70">
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Outro + CTA */}
      <section className="bg-noir text-paper px-6 md:px-12 lg:px-20 py-24 md:py-36">
        <Reveal>
          <p className="serif italic text-3xl md:text-5xl leading-[1.1] max-w-3xl">{s.outro}</p>
        </Reveal>
      </section>
    </div>
  );
}
